module.exports = __webpack_public_path__ + "img/additem.85e7ba61.svg";